import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import * as XLSX from "xlsx";
import { getToken, base_url } from "../../config/config";

const CalculatedReport = () => {
  const [apiData, setApiData] = useState([]);
  const [dataFilter, setDataFilter] = useState("all"); // Filter for "Pending" or "All"
  const [totalEinzelpreis, setTotalEinzelpreis] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [finalTotal, setFinalTotal] = useState(0);
  const [open, setOpen] = useState(false);
  const [selectedUserDetails, setSelectedUserDetails] = useState(null);

  // Fetch API data based on the selected filter
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${base_url}/v1/getBulkreport?filter=${dataFilter}`,
        );
        if (response.data.status === 1) {
          const data = response.data.data;
          setApiData(data);

          // Calculate totals
          let totalEinzelpreis = 0;
          let totalProfit = 0;

          data.forEach((item) => {
            totalEinzelpreis += parseFloat(item.Einzelpreis) || 0;
            totalProfit += parseFloat(item.profitOrLoss) || 0;
          });

          setTotalEinzelpreis(totalEinzelpreis);
          setTotalProfit(totalProfit);
          setFinalTotal(totalEinzelpreis - totalProfit);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    };

    fetchData();
  }, [dataFilter]);

  // Define table columns including a button to view user details
  const columns = useMemo(
    () => [
      { accessorKey: "ANR", header: "ANR" },
      { accessorKey: "Einzelpreis", header: "Price" },
      { accessorKey: "totalHours", header: "Total Hours" },
      { accessorKey: "costByUser", header: "Cost by User" },
      { accessorKey: "profitOrLoss", header: "Profit/Loss" },
      {
        id: "viewUsers",
        header: "View Users",
        Cell: ({ row }) => (
          <Button
            variant='outlined'
            color='primary'
            onClick={() => {
              setSelectedUserDetails(row.original.users);
              setOpen(true);
            }}>
            View Users
          </Button>
        ),
      },
    ],
    [],
  );

  // Handle export to Excel
  const handleExport = () => {
    const worksheet = XLSX.utils.json_to_sheet(apiData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
    XLSX.writeFile(workbook, "projects.xlsx");
  };

  // Handle close modal
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ margin: "20px" }}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <FormControl style={{ minWidth: 120 }}>
          <InputLabel>Data Filter</InputLabel>
          <Select
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
            label='Data Filter'>
            <MenuItem value='all'>All</MenuItem>
            <MenuItem value='np'>Non-Pending</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant='contained'
          color='primary'
          onClick={handleExport}
          style={{ marginBottom: "20px" }}>
          Export Data to Excel
        </Button>
      </div>
      <Typography variant='h6'>
        Total Einzelpreis: {totalEinzelpreis.toFixed(2)}
      </Typography>
      <Typography
        variant='h6'
        style={{ color: totalProfit >= 0 ? "green" : "red" }}>
        Total Profit: {totalProfit.toFixed(2)}
      </Typography>
      <Typography
        variant='h6'
        style={{ color: finalTotal >= 0 ? "green" : "red" }}>
        Final Total: {finalTotal.toFixed(2)}
      </Typography>
      <div id='table-container' style={{ overflow: "hidden" }}>
        <MaterialReactTable columns={columns} data={apiData} />
      </div>

      {/* Dialog for viewing user details */}
      <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
        <DialogTitle>User Details</DialogTitle>
        <DialogContent>
          {selectedUserDetails && selectedUserDetails.length > 0 ? (
            selectedUserDetails.map((user, index) => (
              <div key={index} style={{ marginBottom: "15px" }}>
                <Typography variant='subtitle1'>
                  <strong>User:</strong> {user.user}
                </Typography>
                <Typography variant='body2'>
                  <strong>Description:</strong> {user.description}
                </Typography>
                <Typography variant='body2'>
                  <strong>Total Time:</strong> {user.totalTime} hours
                </Typography>
              </div>
            ))
          ) : (
            <Typography>No user details available.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CalculatedReport;
